export default __webpack_public_path__ + "static/media/alarm-clock.dc386c99.gif";